import { Button, Control, Input, Select } from "@allxsmith/bestax-bulma";
import React, {useState} from "react";
import axios from "axios";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";


export default function PaymentRow({
                                     endpoint,
                                     index,
                                     handleChange,
                                     handleDelete,
                                     payment,
                                     allowDelete,
                                     departments,
                                     departmentObjects
                                   }) {
  const typeFields = ["BACS", "CASH", "CARD", "DIRECT DEBIT"];
  const [, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [typeahead, setTypeahead] = useState();

  const handleCustomerSelect = e => {
    handleChange(
      {
        target: {
          name: "contact",
          value: e[0]
        }
      },
      index
    );
  };

  const handleClear = e => {
    typeahead.getInstance().clear();
    handleChange(
      {
        target: {
          name: "contact",
          value: undefined
        }
      },
      index
    );
    // props.contactUpdate(undefined);
  };

  const onDepartmentChange = (e,index) => {
      const toUpdate = {
          target: {
              name: "department",
              value: departmentObjects[e.target.value]
          }
      };
      handleChange(toUpdate, index);
  }

  const handleSearch = query => {
    setLoading(true);
    axios.get(endpoint + `contacts?&search=${query}&contact_type=CC`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  return (
    <tr key={payment.key}>
      <td>
        <AsyncTypeahead
          useCache={false}
          isLoading={false}
          id="typeahead"
          labelKey="display_name"
          minLength={2}
          name={"display_name"}
          onSearch={handleSearch}
          onChange={handleCustomerSelect}
          placeholder={`Search Customer`}
          selected={payment.contact ? [payment.contact] : []}
          options={searchData}
          ref={typeahead => setTypeahead(typeahead)}
          className="typeahead"
        />
      </td>
      <td>
          <DepartmentSelector
            options={departments}
            value={payment.department}
            disabled={false}
            inlineEdit={false}
            editable={true}
            name={"department"}
            blank={true}
            onChange={(e) => onDepartmentChange(e, index)}
          />
      </td>
      <td>
        <Control>
          <Input
            type="text"
            name="invoice_number"
            onChange={e => handleChange(e, index)}
            value={payment.invoice_number}
          />
        </Control>
      </td>
      <td>
        <Control>
          <Input
            type="number"
            name="amount"
            onChange={e => handleChange(e, index)}
            value={payment.amount}
            className={"wide-column"}
          />
        </Control>
      </td>
      <td>
        <Control>
          <Select
            name="payment_type"
            value={payment.payment_type}
            onChange={e => handleChange(e, index)}
          >
            {typeFields.map(value => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
          </Select>
        </Control>
      </td>
      <td>
        <Control>
          <Input
            type="date"
            value={payment.payment_date || ""}
            name="payment_date"
            onChange={e => handleChange(e, index)}
          />
        </Control>
      </td>
      {useEditableTableTextAreaCell({
        propName: "comments",
        value: payment.comments,
        onChange: e => handleChange(e, index),
        editable: true
      })}
      {allowDelete &&
          <td>
            <Button
              color="danger"
              data-testid={`submit-payment-delete${payment.id}`}
              onClick={() => handleDelete(index)}
            >
              X
            </Button>
          </td>
      }
    </tr>
  );
}
